import { types } from 'mobx-state-tree'
import { TopicPctCorrectSummary } from './TopicPctCorrectSummary'

export const UserTopicKnowledgeGaps = types.model('UserTopicKnowledgeGaps').props({
  strongestTopics: types.array(TopicPctCorrectSummary),
  weakestTopics: types.array(TopicPctCorrectSummary),
})
